import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import { OfflineSyncProvider } from "./lib/OfflineSyncContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Customers from "./pages/Customers";
import Reservations from "./pages/Reservations";
import POS from "./pages/POS";
import Bookings from "./pages/Bookings";
import Reminders from "./pages/Reminders";
import Referrals from "./pages/Referrals";
import Survey from "./pages/Survey";
import Settings from "./pages/Settings";
import Receipt from "./pages/Receipt";
import PublicBook from "./pages/PublicBook";
import Trash from "./pages/Trash";
import OfflineQueue from "./pages/OfflineQueue";
import AuditLog from "./pages/AuditLog";

function Protected({ children, ownerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-neutral-500">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <OfflineSyncProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/book" element={<PublicBook />} />
            <Route path="/survey/:rentalId" element={<Survey />} />
            <Route path="/receipt/:rentalId" element={<Protected><Receipt /></Protected>} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="pos" element={<POS />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="customers" element={<Customers />} />
              <Route path="reservations" element={<Reservations />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="referrals" element={<Referrals />} />
              <Route path="settings" element={<Protected ownerOnly><Settings /></Protected>} />
              <Route path="trash" element={<Protected ownerOnly><Trash /></Protected>} />
              <Route path="offline-queue" element={<OfflineQueue />} />
              <Route path="audit-logs" element={<Protected ownerOnly><AuditLog /></Protected>} />
            </Route>
          </Routes>
          </OfflineSyncProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
